import React, { useState } from 'react'
import { BrowserRouter, Routes, Route, NavLink ,Link} from "react-router-dom"
import Contact from './Contact'
import { Import, LogIn, Menu } from "lucide-react";

import "./Navbar.css"

function Navbar() {
      const [open,setIsOpen]=useState(false)
    
  return (
    <>
      <div className="App">
        <div className="navbar">
          <div className="nav__logo" id='nav-logo'><Link to="/"><span className='morara'>Morara Home </span> Furniture</Link></div>
          <div className={`nav ${open ? "active" : ""}`} id='nav'>
<span  className="closeMark" onClick={()=>{setIsOpen(prevState=>!prevState)}}> x</span>
<NavLink to="/search"  className="nav-link" onClick={()=>{setIsOpen(false)}}><i class="fa-solid fa-magnifying-glass"></i></NavLink>


<NavLink to="/"  className="nav-link" onClick={()=>{setIsOpen(false)}}>Home</NavLink>

<NavLink to="/quote" className="nav-link" onClick={()=>{setIsOpen(false)}}>Get A Quote</NavLink>
    

<NavLink to="/about" className="nav-link" onClick={()=>{setIsOpen(false)}}>About</NavLink>


    

    <NavLink  to="/contact" className="nav-link" onClick={()=>{setIsOpen(false)}}>Contact</NavLink>


   
    <NavLink  to="/location" className="nav-link" onClick={()=>{setIsOpen(false)}}>Our Location</NavLink>

    <NavLink to="/FAQ" className="nav-link"  onClick={()=>{setIsOpen(false)}}>FAQ</NavLink>

           </div>
<Menu className="hamurger" onClick={()=>{setIsOpen(prevState=>!prevState)}}/>

        </div>
      </div>
    </>
  )
}

export default Navbar
